// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export type MenuItem = {
	id: string;
	text: string;
	i18n: string;
	link: string;
	href: string | null;
	target: string | null;
	icon: string;
};

export interface IMenuItem {
	id: string;
	text: string;
	i18n: string;
	link?: string;
	href?: string | null;
	target?: string | null;
	icon?: string;
	items?: IMenuItem[];
	contextItems?: IMenuItem[];
}

export class MenuListDto extends ItiBaseDto implements MenuItem {
	public text: string;
	public i18n: string;
	public link: string;
	public href: string | null;
	public target: string | null;
	public icon: string;
	public items!: MenuItem[];
	public contextItems!: MenuItem[];

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
